
import { defineComponent } from "vue";
import mainHeader from "@/components/header.vue";
import mainFooter from "@/components/footer.vue";
import scrollToTop from "@/components/scrollToTop.vue";
import shortenForm from "@/components/form.vue";
import stats from "@/components/stats.vue";
import cta from "@/components/cta.vue";
import hero from "@/components/hero.vue";

export default defineComponent({
  name: "Home",
  components: {
    mainHeader,
    mainFooter,
    shortenForm,
    stats,
    cta,
    scrollToTop,
    hero,
  },
});
